<template>
  <div class="app-container news-publish">
    <basic-container>

      <el-form ref="publishForm" :model="publishForm" :rules="publishRules" label-width="80px">
        <el-form-item>
          <el-button type="primary" class="news-publish-save"
          @click="handlePublishSave('publishForm')">保存</el-button>
          <el-button class="news-publish-cancel"
          @click="cancelPublish('publishForm')">取消</el-button>
        </el-form-item>
        <el-form-item label="标题" prop="title" class="news-publish-item">
          <el-input v-model="publishForm.title"></el-input>
        </el-form-item>
        <el-form-item label="摘要" class="news-publish-summary">
          <el-input type="textarea" :rows="6" :maxlength="500" v-model="publishForm.summary"></el-input>
        </el-form-item>
        <el-form-item label="标签" class="news-publish-item">
          <el-select v-model="publishForm.tagIds" placeholder="请选择" multiple filterable remote :remote-method="remoteSearchTag">
            <el-option
              v-for="item in tagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="isBanned" class="news-publish-item">
          <el-select v-model="publishForm.isBanned" placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源" prop="source.name" class="news-publish-item">
          <el-input v-model="publishForm.source.name"></el-input>
        </el-form-item>
        <el-form-item label="URL" prop="source.url" class="news-publish-item">
          <el-input v-model="publishForm.source.url"></el-input>
        </el-form-item>
      </el-form>

    </basic-container>
  </div>
</template>

<script>
  import { putBasicNews, putNews, addNews, delNewsSources, addNewsSource } from '@/api/news/news'
  import { getTagList, getTagListByTag } from '@/api/dict/tag'
  import { mapGetters } from 'vuex'
  export default {
    name: 'publishForm',
    data () {
      return {
        publishing: false,
        publishForm: {
          title: '',
          summary: '',
          tagIds: [],
          isBanned: null,
          source: {
            name: '',
            url: ''
          }
        },
        publishRules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          isBanned: [
            { required: true, message: '请选择状态', trigger: 'blur'}
          ],
          'source.name': [
            { required: true, message: '请输入来源', trigger: 'blur'}
          ],
          'source.url': [
            { required: true, message: '请输入URL', trigger: 'blur'}
          ]
        },
        tagOptions: [],
        statusOptions: [
          {
            label: "上架",
            value: 0
          },
          {
            label: "下架",
            value: 1
          }
        ],
      }
    },
    watch: {
      $route () {
        this.handlePublish()
      }
    },
    mounted () {
      this.handlePublish()
    },
    methods: {
      validate () {
        if (!this.publishForm.title || this.publishForm.title.length == 0) {
          this.$message({
            message: '资讯标题不能为空',
            type: 'error'
          })
          return false
        }
        if (this.publishForm.isBanned == null) {
          this.$message({
            message: '资讯状态不能为空',
            type: 'error'
          })
          return false
        }
        if (!this.publishForm.source.name || this.publishForm.source.name.length == 0) {
          this.$message({
            message: '资讯来源不能为空',
            type: 'error'
          })
          return false
        }
        if (!this.publishForm.source.url || this.publishForm.source.url.length == 0) {
          this.$message({
            message: '资讯URL不能为空',
            type: 'error'
          })
          return false
        }
        return true
      },
      handlePublish() {
        // 发布资讯页面第一个调取的方法
        this.publishForm = {
          title: "",
          summary: "",
          tagIds: [],
          isBanned: null,
          source: {
            name: "",
            url: ""
          }
        }
        if (this.$refs['publishForm']) {
          this.$refs['publishForm'].resetFields();
        }
        // this.getCurrentTags('tagOptions')
      },
      handlePublishSave(formName) {
        // 保存按键调取此方法
        let _this = this
        if (_this.publishing) { return false }
        if (!_this.validate()) { return false }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            let news = {
              title: _this.publishForm.title,
              summary: _this.publishForm.summary,
              isBanned: _this.publishForm.isBanned,
              sources: [{
                articleTitle: _this.publishForm.title,
                sourceName: _this.publishForm.source.name,
                articleUrl: _this.publishForm.source.url
              }]
            }
            news.newsTags = _this.getPublishNewsTags(_this.publishForm.tagIds)
            _this.publishing = true
            addNews(news).then(response => {
              let code = response.status
              _this.publishing = false
              if (code == 200) {
                _this.$message({
                  showClose: true,
                  message: '发布成功',
                  type: 'success'
                })
                this.$router.replace({
                  path: `/news/news/detail/${response.data.data}`,
                })
              } else {
                _this.$message({
                  showClose: true,
                  message: '发布失败',
                  type: 'error'
                })
              }
            }).catch(function () {
              _this.publishing = false
              _this.$message({
                showClose: true,
                message: '发布失败',
                type: 'error'
              })
            })
          } else {
            return false;
          }
        });
      },
      cancelPublish(formName) {
        // 取消按键调取此方法
        // init data
        this.publishForm = {
          title: "",
          summary: "",
          tagIds: [],
          isBanned: null,
          source: {
            name: "",
            url: ""
          }
        }
        this.$router.replace({
          path: `/news/news`,
        })
      },
      getPublishNewsTags(tagIds) {
        let newsTags = []
        if (tagIds && tagIds.length > 0) {
          tagIds.forEach(function(tagId, index) {
            newsTags.push({
              newsTagId: tagId
            })
          })
        }
        return newsTags
      },
      remoteSearchTag (params) {
        let _this = this
        if (params && params.trim()) {
          getTagListByTag({
            tagName: params.trim(),
            tagTypeId: 4
          }).then(response => {
            if (response.status === 200) {
              let tags = response.data.data
              _this.tagOptions = []
              if (tags && tags.length > 0) {
                tags.forEach(function(tag, index) {
                  _this.tagOptions.push({
                    label: tag.name,
                    value: tag.id
                  })
                })
              }
            }
          }).catch(error => {
            console.error(error)
            this.$message({
              message: "获取标签失败",
              type: "error"
            })
          })
        }
      },
      getCurrentTags(property) {
        let _this = this
        let tags = []
        let params = {
          type: 4
        }
        getTagList(params).then(response => {
          if (response.status == 200) {
            tags = response.data.data
            if (property == 'tagOptions') {
              _this.tagOptions = []
              if (tags && tags.length > 0) {
                tags.forEach(function(tag, index) {
                _this.tagOptions.push(
                  {
                    label: tag.name,
                    value: tag.id
                  })
                })
              }
            }
          }
        })
        return tags
      },
    },
  }
</script>

<style lang="scss" scoped>
.news-publish {
  .news-publish-save {
    padding: 8px 12px;
    float: right;
  }
  .news-publish-cancel {
    padding: 8px 12px;
    float: right;
    margin-right: 10px;
  }
  &-item{
    width: 600px;
  }
  &-summary{
    width: 1000px;
  }
}
</style>
